import { Crm2Board } from "@/components/crm-demos/crm-2-board"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-2")({
  component: Crm2Page,
  head: () => ({ meta: [{ title: "CRM 2 · Deal Pipeline Board" }] }),
});

function Crm2Page() {
  return <Crm2Board />
}
